import { ActionIcon, Button, Menu, type ActionIconProps, type ButtonProps, type MenuItemProps } from '@mantine/core';
import type { LinkProps, RegisteredRouter } from '@tanstack/react-router';
import { createLink } from '@tanstack/react-router';
import { forwardRef } from 'react';

export type _LinkProps<To extends string> = Omit<LinkProps<'a', RegisteredRouter, string, To>, '_'>;

export const _LinkActionIcon = forwardRef<HTMLAnchorElement, ActionIconProps>((props, ref) => {
  return <ActionIcon ref={ref} component="a" {...props} />;
});
export const LinkActionIcon = createLink(_LinkActionIcon);

export const _LinkButton = forwardRef<HTMLAnchorElement, ButtonProps>((props, ref) => {
  return <Button ref={ref} component="a" {...props} />;
});
export const LinkButton = createLink(_LinkButton);

const _LinkMenuItem = forwardRef<HTMLAnchorElement, MenuItemProps>((props, ref) => {
  return <Menu.Item ref={ref} component="a" {...props} />;
});
export const LinkMenuItem = createLink(_LinkMenuItem);
